import { render } from "./Horarios.vue?vue&type=template&id=50a939b8&scoped=true"
import script from "./Horarios.vue?vue&type=script&lang=js"
export * from "./Horarios.vue?vue&type=script&lang=js"

import "./Horarios.vue?vue&type=style&index=0&id=50a939b8&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a939b8"]])

export default __exports__